import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);
  
  border-top: 2px solid var(--primary);
  border-right: 2px solid var(--primary);
  border-bottom: 2px solid var(--primary);
  border-left: 2px solid var(--secondary);
  background: transparent;
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const Container = styled.div`
    display: flex;
    padding-bottom: 12px;
    padding-top: 12px;
`;

export const Paragraph = styled.h3`
    margin-left: 12px;
`;